<template>
  <nuxt-link :to="url" class="news-category-item" :class="[`news-category-item--${resource.columns.focus}`]">
    <div v-if="resource.columns.teaser_asset" class="news-category-item__asset">
      <Media :path="resource.columns.teaser_asset" />
    </div>
    <div class="news-category-item__content">
      <p v-if="resource.columns.date">
        {{ date }}
      </p>
      <Headline v-if="resource.columns.title" :size="2">
        {{ resource.columns.title }}
      </Headline>
      <p v-if="resource.columns.teaser_text" class="news-category-item__text">
        {{ resource.columns.teaser_text }}
      </p>
    </div>
    <div class="news-category-item__action">
      <ArrowIcon class="news-category-item__icon" />
    </div>
  </nuxt-link>
</template>

<script>
import formatDate from 'beisheim/utils/format-date'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Headline from 'beisheim/components/elements/headline'
import Media from 'beisheim/components/elements/media'
import ArrowIcon from 'beisheim/assets/images/icons/beisheim-stiftung-arrow.svg'

export default {
  components: {
    Headline,
    Media,
    ArrowIcon
  },
  mixins: [editable],
  computed: {
    url () {
      return this.resource.url || '/'
    },
    date () {
      if (!this.resource.columns.date) { return false }
      return formatDate(this.resource.columns.date)
    }
  }
}
</script>

<style lang="scss">
  @import "~beisheim/scss/font";
  @import "~beisheim/scss/colors";
  @import "~beisheim/scss/breakpoints";
  @import "~beisheim/scss/line-heights";

  $news-category-breakpoint: 4;

  .news-category-item {
    margin-left: -2rem;
    border-bottom: 1px solid gray(4);
    transition: background-color 200ms ease-in-out;
    user-select: none;

    @include from($news-category-breakpoint) {
      display: flex;
      align-items: center;
      border-left: 1rem solid gray(4);
    }

    &__asset {
      border-left: 1rem solid gray(4);

      @include from($news-category-breakpoint) {
        border-left: none;

        img {
          width: 12.5rem;
          height: 12.5rem;
          object-fit: cover;
        }
      }
    }

    &__text {
      overflow: hidden;
      line-height: line-height(3);
      max-height: line-height(3) * 1em * 3;

      @include from($news-category-breakpoint) {
        max-height: line-height(3) * 1em * 4;
      }
    }

    &__content {
      padding: 1rem;
      flex: 1;

      @include from($news-category-breakpoint + 2) {
        margin-right: 2rem;
      }

      @include to($news-category-breakpoint - 1) {
        border-left: 1rem solid gray(4);
      }
    }

    &__action {
      display: none;

      @include from($news-category-breakpoint) {
        display: flex;
        align-items: center;
      }

      @include from($news-category-breakpoint + 2) {
        padding: 1rem;
      }
    }

    &--bildung,
    &--bildung &__content,
    &--bildung &__asset {
      border-left-color: brand(3);
    }

    &--gesundheit,
    &--gesundheit &__content,
    &--gesundheit &__asset {
      border-left-color: brand(4);
    }

    &--kultur,
    &--kultur &__content,
    &--kultur &__asset {
      border-left-color: brand(1);
    }

    &--sport,
    &--sport &__content,
    &--sport &__asset {
      border-left-color: brand(2);
    }

    &:hover {
      background-color: gray(4);
    }

    &:hover &__icon {
      transform: translateX(10px);
    }

    &__icon {
      width: 2rem;
      margin-left: 1rem;
      fill: gray(3);
      transition: transform 200ms ease-in-out;
    }
  }
</style>
